module.exports = __webpack_public_path__ + "img/adult_attention.6fb8d8f.png";